import { FC } from 'react'
import clsx from 'clsx'

import CheckBox from '../../../parts/checkbox/checkbox'

import { ICheckbox } from 'constants/types/search.types'

import styles from './checkboxes.module.scss'

interface ICheckboxes {
  datasets: ICheckbox[]
  values: string[]
  handler: (value: string[]) => void
  isSingleChoise?: boolean
  rowPosition?: boolean
}

const Checkboxes: FC<ICheckboxes> = ({
  datasets,
  values,
  handler,
  isSingleChoise,
  rowPosition,
}: ICheckboxes) => {
  const handleClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checkbox = e.target?.dataset?.checkbox
    if (checkbox) {
      if (values?.includes(checkbox)) {
        const newValues = values.filter((item) => item !== checkbox)
        return handler(newValues)
      }
      if (isSingleChoise) {
        const newValues = [checkbox]
        return handler(newValues)
      }
      return handler([...values, checkbox])
    }
  }
  const isSingleOption = datasets?.length === 1
  return (
    <div
      className={clsx(styles.checkboxes, {
        [styles.checkboxesSingle]: isSingleOption,
        [styles.checkboxesRow]: rowPosition,
      })}
    >
      {datasets.map(({ label, value }) => {
        const isActive = values?.includes(value)

        return (
          <div className={clsx(styles.checkbox, { [styles.checkboxRow]: rowPosition })} key={value}>
            <CheckBox checked={isActive} data-checkbox={value} onChange={handleClick}>
              {label}
            </CheckBox>
          </div>
        )
      })}
    </div>
  )
}

export default Checkboxes
